import { CustomerSegment } from '../../@types/CustomerSegment';
import { DsaStatus } from '../../@types/DsaStatus';
import { CustomerVerificationStatus } from '../../api/tvs/customer/model/CustomerVerificationStatus';
import {
  DSA_DOCUMENTS_IN_REVIEW_PATH,
  DSA_DOCUMENTS_PENDING_PATH,
  DSA_DOCUMENTS_REVIEWED_PATH,
  DSA_DOCUMENT_CHECK_FAILED_PATH,
  DSA_VERIFICATION_BASE_PATH,
  DSA_VERIFICATION_ERROR_PATH,
} from '../../routePaths';

export const resolvedVerificationRoutes = [
  DSA_VERIFICATION_ERROR_PATH,
  DSA_DOCUMENTS_PENDING_PATH,
  DSA_DOCUMENTS_IN_REVIEW_PATH,
  DSA_DOCUMENTS_REVIEWED_PATH,
];

export const isResolvedVerificationRoute = (pathname: string): boolean => resolvedVerificationRoutes.includes(pathname);

export const resolveVerificationRoutePath = (verificationStatus: CustomerVerificationStatus): string => {
  const isEligibleCustomerSegment =
    verificationStatus.customerSegment === CustomerSegment.NON_CORE_COMMERCIAL_CUSTOMER ||
    verificationStatus.customerSegment === CustomerSegment.CORE_CUSTOMER;

  if (!isEligibleCustomerSegment) {
    return DSA_VERIFICATION_ERROR_PATH;
  }

  switch (verificationStatus.dsaStatus) {
    case DsaStatus.IN_REVIEW:
      return DSA_DOCUMENTS_IN_REVIEW_PATH;
    case DsaStatus.VERIFIED:
      return DSA_DOCUMENTS_REVIEWED_PATH;
    case DsaStatus.PENDING:
      return DSA_DOCUMENTS_PENDING_PATH;
    default:
      return DSA_VERIFICATION_BASE_PATH;
  }
};

export const resolveInReviewVerificationRoutePath = (verificationStatus: CustomerVerificationStatus): string => {
  if (
    verificationStatus.customerSegment === CustomerSegment.NON_CORE_COMMERCIAL_CUSTOMER &&
    verificationStatus.dsaStatus === DsaStatus.NOT_VERIFIED
  ) {
    return DSA_DOCUMENT_CHECK_FAILED_PATH;
  }

  return resolveVerificationRoutePath(verificationStatus);
};
